import React from "react";
import styled from "styled-components";
import { theme } from "../../../theme";

interface Props {
  title: string;
}
const TitleForm: React.FC<Props> = ({ children, title }) => {
  return (
    <StyledFormContainer>
      <FormTitle>{title}</FormTitle>
      <Formbody>{children}</Formbody>
    </StyledFormContainer>
  );
};
export default TitleForm;
const StyledFormContainer = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 40px;
  border-radius: 8px;
  padding-bottom: 40px;

  /* height: calc(100vh - 230px); */
  overflow-y: auto;
`;
const FormTitle = styled.div`
  width: 100%;

  padding: 16px 24px;
  ${theme.colors.gray1};
  ${theme.typo.heading.b18};
  box-shadow: inset 0px -1px 0px #eeeff4;
`;
const Formbody = styled.div`
  width: 100%;
  padding: 24px 24px 40px;
`;
